import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { BASEURL, RESTAURANT_INVOICES } from './../api/endpoints.js';
import getCookie from '../utils/getCookie.js';

export const restaurantInvoicesApi = createApi({
    reducerPath: 'restaurantInvoicesApi',
    baseQuery: fetchBaseQuery({
        baseUrl: BASEURL + RESTAURANT_INVOICES,
        prepareHeaders: (headers) => {
            headers.set('Authorization', `Bearer ${getCookie('accessToken')}`);
            headers.set('Content-Type', 'application/json');
            return headers;
        }
    }),
    tagTypes: ['RestaurantInvoice'],
    endpoints: (builder) => ({

        getLastInvoiceNo: builder.query({
            query: (warehouse) => ({
                url: `/AppGetLastInvoiceNo?Warehouse=${warehouse}`,
            }),
        }),

        getInvoicesByDate: builder.query({
            query: ({ fromDate, toDate, warehouse }) => ({
                url: `/ByIntervalDate?FromDate=${fromDate}&ToDate=${toDate}&Warehouse=${warehouse}`,
            }),
            providesTags: ['RestaurantInvoice'],
        }),

        getInvoiceByInvoiceNo: builder.query({
            query: (invoiceNo) => ({
                url: `/AppGetByInvoiceNo?InvoiceNo=${String(invoiceNo)}`,
            }),
            transformResponse: (response) => response.Response,
            providesTags: ['RestaurantInvoice'],
        }),

        insertInvoice: builder.mutation({
            query: ({ invoices, invoiceDtl, invoicePayment }) => ({
                url: '/Insert',
                method: 'POST',
                body: {
                    invoices,
                    invoiceDtl,
                    invoicePayment
                },
            }),
            invalidatesTags: ['RestaurantInvoice'],
        }),
    }),
});


export const {
    useGetLastInvoiceNoQuery,
    useGetInvoicesByDateQuery,
    useGetInvoiceByInvoiceNoQuery,
    useInsertInvoiceMutation,
} = restaurantInvoicesApi;
